import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import settings from "../../../settings";
import Address from "../../searchresults/Address";
import VehicleDetails from "./VehicleDetails";
import getPersonName from "../../common/Name";

class MotorVehiclesSilverReport extends Component {
  state = {
    activeIndex: 0,
    rows: [],
  };

  componentDidMount() {
    this.loadSection(this.props);
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadSection = (props) => {
    const records = _.get(props.node, "vehicles[0].vehicle");
    const rows = [];
    let vehCount = 0;
    if (records !== undefined) {
      const vehIds = [];
      _.forEach(records, (record, index) => {
        const innerRows = [];
        const curVehRecId = _.get(record, "VIN[0]._");
        if (!vehIds.includes(curVehRecId)) {
          vehIds.push(curVehRecId);
          const year = _.get(record, "modelYear[0]._", "");
          const make = _.get(record, "make[0]._", "");
          const model = _.get(record, "model[0]._", "");
          const series = _.get(record, "series[0]._", "");
          const vinNumber = _.get(record, "VIN[0]._", "");

          const fullName = this.fullName(record);
          const persDetails = this.persDetails(record);
          innerRows.push(
            <Table.Row key={`veh_name_row_${index}`}>
              <Table.Cell width={2}>Name:</Table.Cell>
              <Table.Cell width={6}>
                {persDetails.firstName !== ""
                  ? getPersonName(
                      persDetails.firstName,
                      "",
                      persDetails.lastName,
                      props
                    )
                  : fullName}
              </Table.Cell>
              <Table.Cell width={2}>Year/Make:</Table.Cell>
              <Table.Cell
                width={6}
              >{`${year} ${make} ${model} ${series}`}</Table.Cell>
            </Table.Row>
          );
          innerRows.push(
            <Table.Row key={`veh_add_row_${index}`}>
              <Table.Cell width={2}>Address:</Table.Cell>
              <Table.Cell width={6}>
                {persDetails.addressNode && (
                  <Address addressNode={persDetails.addressNode} {...props} />
                )}
              </Table.Cell>
              <Table.Cell width={2}>VIN: </Table.Cell>
              <Table.Cell width={6}>{vinNumber}</Table.Cell>
            </Table.Row>
          );
          innerRows.push(
            <Table.Row key={`veh_detail_row_${index}`}>
              <Table.Cell colSpan={4}>
                <VehicleDetails
                  record={record}
                  detailIndex={index}
                  {...props}
                />
              </Table.Cell>
            </Table.Row>
          );
          vehCount += 1;
          rows.push(
            <Table.Row
              key={`veh_info_row_${index}`}
              className={index % 2 === 1 ? "table-row-odd-child" : ""}
            >
              <Table.Cell>
                <Table className="table-no-padding background-color-transparent">
                  <Table.Body>{innerRows}</Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, vehCount);
  };

  fullName = (record) =>
    `${_.get(
      record,
      "vehicleRegistrants[0].vehicleRegistrant[0].name[0].firstName[0]._",
      ""
    )} ${_.get(
      record,
      "vehicleRegistrants[0].vehicleRegistrant[0].name[0].middleName[0]._",
      ""
    )} ${_.get(
      record,
      "vehicleRegistrants[0].vehicleRegistrant[0].name[0].lastName[0]._",
      ""
    )}`;

  persDetails = (record) => {
    const persDetails = {
      firstName: "",
      lastName: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      addressNode: undefined,
    };
    const node = _.get(record, "vehicleRegistrants[0].vehicleRegistrant[0]");
    persDetails.firstName = _.get(node, "name[0].firstName[0]._", "");
    persDetails.lastName = _.get(node, "name[0].lastName[0]._", "");
    persDetails.street = `${_.get(
      node,
      "registrationAddress[0].streetNumber[0]._",
      ""
    )} ${_.get(node, "registrationAddress[0].streetName[0]._", "")} ${_.get(
      node,
      "registrationAddress[0].streetSuffix[0]._",
      ""
    )}`;
    persDetails.city = _.get(node, "registrationAddress[0].city[0]._", "");
    persDetails.state = _.get(node, "registrationAddress[0].state[0]._", "");
    persDetails.zip = _.get(node, "registrationAddress[0].zip[0]._", "");
    persDetails.addressNode = _.get(node, "registrationAddress[0]");
    return persDetails;
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          className="report-section-header"
          key={`MotorVehicle_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Motor Vehicles
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`MotorVehicle_Body`}
          active={this.state.activeIndex === 0}
        >
          {this.state.rows.length < 1 ? (
            <span>No Records Found</span>
          ) : (
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.Cell colSpan={4}>
                    <span>
                      I agree that I, and the organization I represent if
                      applicable, will NOT use the information accessed through
                      this search in whole or in part for the purpose of serving
                      as a factor in establishing a consumer’s eligibility for
                      CREDIT or INSURANCE, EMPLOYMENT purposes, or for any other
                      purpose(s) authorized under section 604 of the Federal
                      Fair Credit Reporting Act (15 U.S.C. Sec. 1681 et seq.)
                      (‘FCRA’) Driver Privacy Protection Act (‘DPPA’) and
                      Gramm–Leach–Bliley Act (‘GLBA’). {settings.appName} is not
                      a consumer reporting agency and {settings.appName} reports
                      do not constitute consumer reports as such terms are
                      defined in the FCRA, DPPA and GLBA and accordingly these
                      reports may not be used for purposes provided for in the
                      FCRA. As this information is compiled from individual
                      sources, {settings.appName} does not guarantee the
                      comprehensiveness or accuracy of these records, nor that
                      they are a complete history of activity.
                    </span>
                  </Table.Cell>
                </Table.Row>
                {this.state.rows}
              </Table.Body>
            </Table>
          )}
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default MotorVehiclesSilverReport;



// WEBPACK FOOTER //
// ./src/components/reports/Silver/MotorVehiclesSilverReport.js